module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-16.cc818a23.png";